var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"balance-output-empty"},[(_vm.icon)?_c('span',{staticClass:"balance-output-empty__icon",class:_vm.icon}):_vm._e(),_c('p',{staticClass:"balance-output-empty__text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }